const files = require.context('', true, /\.js$/)

const modules = {}

files.keys().forEach(file => {
  const name = file.split('/')[1]
  let temp = modules
  file.split('/').forEach(key => {
    if (key != '.') {
      if (key.endsWith('.js')) {
        if (key != 'index.js') {
          key = key.replace('.js', '')
          temp[key] = files(file).default
        }
      } else {
        if (!temp[key]) {
          temp[key] = {}
        }
        temp = temp[key]
      }
    }
  })
})

export default modules
